import { useEffect, useState } from 'react';

function formatDate(d) {
    const [datePart] = d.split("T");
    const [year, month, day] = datePart.split("-");
    return `${day}.${month}.${year}`;
}

function GetData(loaded_data) {

    const [all_posts, setAllPosts] = useState([]);

    useEffect(() => {
        if ( loaded_data === null  ) {
            const host = (process.env.NODE_ENV === 'development') ? 'http://localhost:8080' : '';
            const url = `${host}/api/blog`;

            const fetchData = async () => {
                try {
                    
                    const response = await fetch(url);
                    const api_data = await response.json();

                    let posts = []
                    for (let i = 0; i < api_data.length; i++){
                        posts.push({'title' : api_data[i].title, 'date' : formatDate(api_data[i].date_published), 'urlSlug' : api_data[i].url_slug, 'altText' : api_data[i].image_alt_text})
                    }

                    setAllPosts(posts.reverse());

                } catch (error) {
                    console.log("error", error);
                }

            };
    
            fetchData();
        } else {
            setAllPosts(loaded_data.posts)
        }

    }, [loaded_data]);
    return { all_posts };
}

export default GetData;